import { render, staticRenderFns } from "./RolesAndPermissions.vue?vue&type=template&id=ccc2fd28&"
import script from "./RolesAndPermissions.vue?vue&type=script&lang=js&"
export * from "./RolesAndPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports